import { CreatePatientRequestDTO } from '../../dtos/CreatePatientRequestDTO';
import { User } from '../../entities/User';
import { api } from '../api';

export const createPatientService = async ({
  patientData,
  personalData,
  type,
}: CreatePatientRequestDTO): Promise<User> => {
  const { data } = await api.post('/patients/preRegisterPatient', {
    patientData,
    personalData,
    type,
  });

  return data;
};
